import {
  Box,
  Card,
  CardContent,
  Divider,
  Grid,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
  Button as MatButton,
  Menu,
  MenuItem,
  ButtonGroup,
  Grid2,
} from "@mui/material";
import { useLocation, useNavigate } from "react-router-dom";
import PageHeader, {
  BreadcrumbsModel,
} from "../../../../shared/PageHeader/PageHeader";
import PageWrapper from "../../../../shared/PageWrapper/PageWrapper";
import ViewTableWrapper from "../../../../shared/ViewTableWrapper/ViewTableWrapper";
import { useEffect, useState } from "react";
import CheckOutlinedIcon from "@mui/icons-material/CheckOutlined";
import UpcomingInterviewList from "../../CandidateManagement/CandidateManagementView/components/UpcomingInterviewList";
import UpcomingInterviewCalendar from "../../CandidateManagement/CandidateManagementView/components/UpcomingInterviewCalendar";
import UpcomingInterviewsListing from "./UpcomingInterviewsListing";
import API from "../../../../api/axios";
import { DatePicker, LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import { getUser } from "../../../../utils/types";
import DateRangePicker from "../../../../shared/DateRangePicker/DateRangePicker";

const InterviewCalendarList = () => {
  const navigate = useNavigate();
  const [exportAnchorEl, setExportAnchorEl] = useState(null);
  const [switchView, setSwitchView] = useState<string>("calendar");
  const [calenderViewData, setCalenderViewData] = useState<any>([]);
  const [listViewData, setListViewData] = useState<any>([]);
  const [startDate, setStartDate] = useState<any>();
  const [endDate, setEndDate] = useState<any>();
    const [dateRange, setDateRange] = useState<any>({})
  const userData = getUser();

  let state = useLocation();

  const handleMenuOpen = (setAnchor: any) => (event: any) => {
    setAnchor(event.currentTarget);
  };

  const handleMenuClose = (setAnchor: any) => () => {
    setAnchor(null);
  };

  const handleDateRangeChange = (dateRange: { startDate:string | null; endDate: string | null }) => {
    setDateRange(dateRange);
  };
  
  const switchInterviewHandler = (type?: any) => setSwitchView(type);

  useEffect(() => {
    if (state?.state?.view) {
      setSwitchView(state?.state?.view);
    }
  }, [state?.state?.view]);

  const calenderViewActionClick = (data: any) => {
    navigate("/admin/interview-calendar/view", {
      state: { view: "calendar", calenderData: data },
    });
  };

  const getInterViewData = async () => {
    if (switchView === "calendar") {
      try {
        let response = await API.post(`/interview/candidate/my/calendar`, {
          offset: 0,
          limit: -1,
          viewType:"calendar",
        });
        let newData = response?.data?.data?.map((value: any) => {
          return {
            id: value?.id,
            title: value?.position_name,
            start: `${value?.slot_date}T${value?.start_time}`,
            end: `${value?.slot_date}T${value?.end_time}`,
            extendedProps: {
              position: value?.position_id?.name,
              link: value?.webex_link,
              ...value,
            },
          };
        });
        setCalenderViewData(newData);
      } catch (error) {
        // Failed to fetch interview calendar data
      }
    }
  };

  useEffect(() => {
    getInterViewData();
  }, []);

  return (
    <PageWrapper>
      <PageHeader title="Interview Calendar"></PageHeader>
      <Card className="custom__card" sx={{ marginTop: "1.5rem" }}>
        <CardContent sx={{padding: {xs: 0, md: "16px"}}}>
          <Grid2 container spacing={2}>
            <Grid2 size={{xs: 12, sm: 6, md: 4, lg: 3}} marginBottom={4}>
              <Typography variant="body1">Candidate Name</Typography>
              <Typography variant="subtitle2">
                {userData?.user?.fullname || "NA"}{" "}
              </Typography>
            </Grid2>
            <Grid2 size={{xs: 12, sm: 6, md: 4, lg: 3}} marginBottom={4}>
              <Typography variant="body1">Mobile Number</Typography>
              <Typography variant="subtitle2">
                {userData?.user?.mobile || "NA"}
              </Typography>
            </Grid2>
            <Grid2 size={{xs: 12, sm: 6, md: 4, lg: 3}} marginBottom={4}>
              <Typography variant="body1">Email Address</Typography>
              <Typography variant="subtitle2">
                {userData?.user?.email || "NA"}
              </Typography>
            </Grid2>
            <Grid2 size={{xs: 12, sm: 6, md: 4, lg: 3}} marginBottom={4}>
              <Typography variant="body1">INFRACON Status</Typography>
              <Typography variant="subtitle2">{userData?.user?.is_infracon_verified?"Verified":'Not Verified'}</Typography>
            </Grid2>
          </Grid2>
          <ButtonGroup sx={{ display: "flex", justifyContent: "end" }}>
            <MatButton
              sx={{
                backgroundColor:
                switchView === "list" ? "#F5F5F5" : "transparent",
                color: "#000",
                borderRadius: "50px 0 0 50px !important",
                width: {xs: "50%", sm: "160px", md: "160px"},
                marginTop: {xs: "10px", sm: "0"},
                fontSize: {xs: "12px", md: "14px"},
                height: "2.5rem",
                border: "solid 1px #ddd",
                fontWeight: 400,
              }}
              onClick={() => switchInterviewHandler("list")}
            >
              <CheckOutlinedIcon
                sx={{
                  fontSize: "18px",
                  marginRight: ".4rem",
                  display: switchView === "list" ? "block" : "none",
                }}
              />
              List View
            </MatButton>
            <MatButton
              sx={{
                backgroundColor:
                switchView === "calendar" ? "#F5F5F5" : "transparent",
                color: "#000",
                width: {xs: "50%", sm: "160px", md: "160px"},
                marginTop: {xs: "10px", sm: "0"},
                borderRadius: "0 50px 50px 0 !important",
                fontSize: {xs: "12px", md: "14px"},
                height: "2.5rem",
                border: "solid 1px #ddd",
                fontWeight: 400,
              }}
              onClick={() => switchInterviewHandler("calendar")}
            >
              <CheckOutlinedIcon
                sx={{
                  fontSize: "18px",
                  marginRight: ".4rem",
                  display: switchView === "calendar" ? "block" : "none",
                }}
              />
              Calendar View
            </MatButton>
          </ButtonGroup>
         
          

          <Box marginTop={2}>
            <ViewTableWrapper>
              <ViewTableWrapper.Header title="Scheduled Interviews">
                {switchView !== "calendar" && (
                  <DateRangePicker
                  startDate={startDate}
                  endDate={endDate}
                  onStartDateChange={setStartDate}
                  onEndDateChange={setEndDate}
                  onDateRangeChange={handleDateRangeChange}
                />
                )}
              </ViewTableWrapper.Header>

              <Divider />
              <ViewTableWrapper.Content>
                {switchView === "list" ? (
                  <UpcomingInterviewsListing dateRange={dateRange} />
                ) : (
                  <UpcomingInterviewCalendar
                    data={calenderViewData}
                    handleView={(data: any) => {
                      calenderViewActionClick(data);
                    }}
                  />
                )}
              </ViewTableWrapper.Content>
            </ViewTableWrapper>
          </Box>
        </CardContent>
      </Card>
    </PageWrapper>
  );
};
export default InterviewCalendarList;
